import { use } from 'react';
import ActivityBookingContext from '..';
const useActivityBookingAvailableDates = () => {
    const { setDateRange, loadingAvailableDates, availableDatesQueryError, availableDates } = use(ActivityBookingContext);
    return {
        setDateRange,
        loadingAvailableDates,
        availableDatesQueryError,
        availableDates
    };
};
export default useActivityBookingAvailableDates;
